import React from 'react';
import FocusIcon from '@mui/icons-material/FilterCenterFocus';

import { getSelectedItemIdentifiers } from '../../../../../library/selection/selectors';
import { useAppSelector } from '../../../../hooks';
import { ButtonBarButton, ButtonBarButtonProps } from './common';

export function FocusSelectedButton({ focusGridOnRow, panelContext }: ButtonBarButtonProps) {
  const selectedItems = useAppSelector(getSelectedItemIdentifiers);

  if (panelContext === 'levels') return null;

  const enabled = selectedItems.length === 1;

  return (
    <ButtonBarButton
      title="Focus Selected Row"
      icon={FocusIcon}
      disabled={!enabled}
      onClick={() => {
        focusGridOnRow(selectedItems[0]);
      }}
    />
  );
}
